import { SxProps, Theme } from '@mui/material';
import { Primary, Neutrals } from '../../../core-components/theme/color-palette/colors';

export const emailPreviewDialogStyles = {
  container: {
    p: 2,
  } as SxProps<Theme>,

  subjectLabel: {
    fontWeight: 'bold',
    mb: 1,
  } as SxProps<Theme>,

  subjectText: {
    mb: 3,
  } as SxProps<Theme>,

  messageLabel: {
    fontWeight: 'bold',
    mb: 1,
  } as SxProps<Theme>,

  messageText: {
    mb: 3,
  } as SxProps<Theme>,

  attachmentsLabel: {
    fontWeight: 'bold',
    mb: 2,
  } as SxProps<Theme>,

  attachmentPaper: {
    aspectRatio: '1',
    p: 1,
    display: 'flex',
    boxShadow:'none',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    border: '1px solid',
    borderColor: Neutrals[200],
    position: 'relative',
    overflow: 'hidden',
    width: '120px',
    height: '120px',
    '&:hover': {
      elevation: 3,
      borderColor: Primary[500],
      transform: 'translateY(-2px)',
      '& .download-text': {
        opacity: 1,
      },
      '& .file-info': {
        opacity: 0.3,
      },
    },
  } as SxProps<Theme>,

  downloadOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: 'white',
    flexDirection: 'column',
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out',
    zIndex: 2,
    padding: '4px',
  } as SxProps<Theme>,

  downloadText: {
    fontWeight: 500,
    textAlign: 'center',
    fontSize: '9px',
    lineHeight: 1.2,
    wordBreak: 'break-word',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  } as SxProps<Theme>,

  fileInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  } as SxProps<Theme>,

  pdfIcon: {
    fontSize: 20,
    color: '#d32f2f',
    mb: 0.25,
  } as SxProps<Theme>,

  fileName: {
    textAlign: 'center',
    fontWeight: 500,
    color: Neutrals[700],
    fontSize: '10px',
    lineHeight: 1,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
  } as SxProps<Theme>,
}; 